import { Home, PlusCircle, List, Users, PiggyBank, LogOut } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Navbar({ setUser }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  const item = (path, Icon, label) => (
    <Link to={path} className="flex flex-col items-center">
      <Icon
        size={22}
        className={pathname === path ? "text-green-600" : "text-gray-400"}
      />
      <span className={`text-xs ${pathname === path ? "text-green-600" : "text-gray-400"}`}>
        {label}
      </span>
    </Link>
  );

  const handleLogout = () => {
    localStorage.clear();
    setUser(null); // 🔥 THIS IS THE REAL FIX
    navigate("/");
  };

  return (
    <div className="fixed bottom-0 w-full bg-white border-t shadow-md">

      {/* Top strip */}
      <div className="flex justify-between items-center px-4 py-1 bg-green-50 border-b">
        <span className="text-sm text-gray-700">
          👋 {user?.name || "User"}
        </span>

        <button
          onClick={handleLogout}
          className="flex items-center gap-1 text-red-500 text-sm"
        >
          <LogOut size={16} />
          Logout
        </button>
      </div>

      {/* Bottom nav */}
      <div className="flex justify-around py-2">
        {item("/home", Home, "Home")}
        {item("/add", PlusCircle, "Add")}
        {item("/records", List, "Records")}
        {item("/referrers", Users, "Referrers")}
        {item("/investor", PiggyBank, "Investor")}
      </div>

    </div>
  );
}